// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__PF4Vr","dark":"Toggle_dark__pmlKH","light":"Toggle_light__ZCNOU"};